import React, { useState } from "react"
import {
  concatStrings,
  uniqueId,
} from "@dfb/gatsby-dfb-theme/src/components/utilities"
import DfbSymbol from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_symbol"

const DfbInputUpload = React.forwardRef((props, ref) => {
  const [fileName, setFileName] = useState()
  const required = props.required ? { required: true } : {}
  const disabled = props.disabled ? { disabled: true } : {}
  const disabledClass = props.disabled ? "is-disabled" : ""
  const noLabelClass = props.label ? "" : "dfb-input--plain"
  const errorClass = props.error ? "is-invalid" : ""
  const focusedClass = props.focused ? "is-focused" : ""
  const inputId = uniqueId(`${props.idPrefix}-`)
  const value = props.value != null ? { value: props.value } : {}
  const testid = props.testid ?? null

  const handleChange = event => {
    setFileName(
      Array.from(event.target.files)
        .map(file => file.name)
        .join(", "),
    )
    props.onChange(event)
  }

  return (
    <div
      className={concatStrings(
        "dfb-Input",
        noLabelClass,
        disabledClass,
        errorClass,
        focusedClass,
        props.add_class,
      )}
      data-testid={testid}
    >
      <div className="m-Formblock-dataUpload">
        <div className="m-Formblock-dataUpload-content">
          <input
            ref={ref}
            className="m-Formblock-upload"
            type="file"
            id={inputId}
            accept=".pdf"
            onChange={handleChange}
            onBlur={props.onBlur}
            {...disabled}
            {...value}
            {...required}
            name={props.name}
            multiple={props.multiple}
          />
          <div className="m-Formblock-dataUpload-button">
            <button className="dfb-Button dfb-Button--secondary" type="button">
              <span className="dfb-Button-label"> {props.uploadLabel} </span>
              <span className="dfb-Button-icon">
                <DfbSymbol icon_type="upload" />
              </span>
            </button>
          </div>
          <div className="m-Formblock-dataUpload-help">
            {fileName ? (
              <p className="dfb-Paragraph dfb-Paragraph--small m-Formblock-paragraph">
                {fileName}
              </p>
            ) : (
              <p className="dfb-Paragraph dfb-Paragraph--small m-Formblock-paragraph">
                Drag and Drop
              </p>
            )}
          </div>
          <div className="m-Formblock-dataUpload-status">
            {fileName ? (
              <p className="dfb-Paragraph dfb-Paragraph--small m-Formblock-paragraph">
                {fileName}
              </p>
            ) : (
              <p className="dfb-Paragraph dfb-Paragraph--small m-Formblock-paragraph">
                Keine Datei ausgewählt
              </p>
            )}
          </div>
        </div>
        <div className="m-Formblock-caption">
          Hier kannst du zusätzlich Dateien hochladen, die den Mitgliedern zum
          Download bereit gestellt werden. Bitte beachte folgende Richtlinien:
          Format: PDF.
        </div>
      </div>
      <p className="dfb-Paragraph dfb-Paragraph--small dfb-Input-errorMessage">
        {props.errorMessage}
      </p>
    </div>
  )
})
DfbInputUpload.defaultProps = {
  tagName: "input",
  idPrefix: "input",
  required: false,
  disabled: false,
  error: false,
}

export default DfbInputUpload
